/* PlannerSubmissionFlagAlert — iter98.99br
 *
 * Yellow alert pinned to the top of the planner's Submission tab
 * surface when the doctor's brief contains anything the planner
 * should EXPLICITLY confirm before starting authoring. Today this
 * shows for extractions (the most common surprise) — extends to
 * more rules later (CBCT flagged but missing, perio critical, etc.)
 * without changing call sites.
 *
 * Empty render if nothing to flag — the parent can mount this
 * unconditionally.
 */
import React from "react";
import { Warning } from "@phosphor-icons/react";


export default function PlannerSubmissionFlagAlert({ c }) {
    const cl = c?.clinical || {};
    const flags = [];

    if (cl.extraction_plan === "planned") {
        flags.push({
            title: "Extractions noted",
            text: cl.extraction_teeth
                ? `Doctor indicated extractions on teeth ${cl.extraction_teeth}. Confirm extraction timing with the doctor before authoring.`
                : "Doctor indicated extractions but didn't specify teeth. Confirm with the doctor before authoring.",
        });
    }
    if (cl.periodontal_health === "poor" || cl.periodontal_health === "critical") {
        flags.push({
            title: `Periodontal status: ${cl.periodontal_health}`,
            text: "Doctor flagged compromised periodontal status. Review records carefully and consider scheduling a perio review before staging.",
        });
    }
    if (cl.cbct_available === true) {
        flags.push({
            title: "CBCT available",
            text: "Doctor flagged a CBCT scan as available. Confirm it's been uploaded under Records below.",
        });
    }

    if (flags.length === 0) return null;
    return (
        <div className="space-y-2" data-testid="planner-submission-flag-alert">
            {flags.map((f, i) => (
                <div
                    key={i}
                    className="rounded-xl bg-amber-50 border border-amber-200 px-4 py-3 flex items-start gap-3"
                >
                    <Warning size={18} weight="fill" className="text-amber-600 shrink-0 mt-0.5" />
                    <div className="flex-1">
                        <div className="text-xs font-bold text-amber-900">⚠ {f.title}</div>
                        <div className="text-[11.5px] text-amber-800/85 mt-0.5 leading-relaxed">{f.text}</div>
                    </div>
                </div>
            ))}
        </div>
    );
}
